import { render, staticRenderFns } from "./DoctorsListCard.vue?vue&type=template&id=d42ff07a"
import script from "./DoctorsListCard.vue?vue&type=script&lang=js"
export * from "./DoctorsListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports